import { Component, OnInit } from '@angular/core';
import { RichTextContent } from 'contentful';
import { ContentfulComponent } from '~contentful/components/contentful.component';
import { RichTextModel } from '~contentful/models/core/rich-text.model';

@Component({
  selector: 'app-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss'],
})
export class RichTextComponent extends ContentfulComponent<RichTextModel> implements OnInit {
  public html?: string;

  ngOnInit() {
    if (this.model.obj) {
      if (this.type(this.model.obj.nodeType)) {
        this.html = this.toHTML();
      }
    }
  }

  private toHTML() {
    const element = this.toElement();
    if (element instanceof HTMLElement) {
      return element.outerHTML;
    } else {
      return element.wholeText;
    }
  }

  private toElement(node: RichTextContent = this.model.obj) {
    const type = this.type(node.nodeType);

    let modifier: HTMLElement = null;
    let firstModifier: HTMLElement = null;

    if (node.marks) {
      node.marks.forEach(({ type: mark }) => {
        const mod = document.createElement(this.type(mark));
        if (modifier) {
          modifier.appendChild(mod);
        } else {
          firstModifier = mod;
        }
        modifier = mod;
      });
    }

    if (type) {
      const element: HTMLElement = document.createElement(type);
      const children = node.content.map((child) => this.toElement(child));
      if (modifier) {
        element.appendChild(modifier);
      }
      const current = modifier || element;
      children.forEach((child) => current.appendChild(child));
      return element;
    }

    if (node.nodeType === 'text') {
      const text = document.createTextNode(node.value);
      if (modifier) {
        modifier.appendChild(text);
      }
      return firstModifier || text;
    }

    return null;
  }

  private type(nodeType: string) {
    switch (nodeType) {
      case 'heading-1':
        return 'h1';
      case 'heading-2':
        return 'h2';
      case 'heading-3':
        return 'h2';
      case 'heading-4':
        return 'h2';
      case 'heading-5':
        return 'h2';
      case 'heading-6':
        return 'h2';
      case 'paragraph':
        return 'p';
      case 'underline':
        return 'u';
      case 'bold':
        return 'b';
      case 'italics':
        return 'i';
    }

    return null;
  }
}
